import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { DataService } from 'src/app/shared/services/data.service';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { MatPaginator as MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UtilsService } from 'src/app/shared/services/utils.service';
// import { ExportToCsv } from 'export-to-csv';
import { mkConfig, generateCsv, download } from 'export-to-csv';

import { RequesterService } from '../../services/requester.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-export-view',
  templateUrl: './export-view.component.html',
  styleUrls: ['./export-view.component.scss'],
  standalone: false
})
export class ExportViewComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  private readonly gaSummaryDefinitions = [
    {
      label: 'Without outlier',
      totalDataPoints: 'totalDataPointsExcludingoutliers',
      targetPacked: 'targetPacked',
      actualPacked: 'actualPackedWithoutOutLier',
      giveAway: 'giveAway',
      giveAwayPercentage: 'giveAwayPercentage',
      lslRejectPercentage: 'lslRejectPercentage'
    },
    {
      label: 'With Obvious Outlier',
      totalDataPoints: 'totalDataPointsObViousOutliers',
      targetPacked: 'targetPacked_ObviousOutLiers',
      actualPacked: 'actualPacked_ObviousOutLiers',
      giveAway: 'giveAway_ObviousOutLiers',
      giveAwayPercentage: 'giveAwayPercentage_ObviousOutLiers',
      lslRejectPercentage: 'lslRejectPercentageObviousOutLiers'
    },
    {
      label: 'With Outlier',
      totalDataPoints: 'totalDataPoints',
      targetPacked: 'targetPacked_RawData',
      actualPacked: 'actualPacked_RawData',
      giveAway: 'giveAway_RawData',
      giveAwayPercentage: 'giveAwayPercentage_RawData',
      lslRejectPercentage: 'lslRejectPercentage_RawData'
    }
  ];

  item: any;
  isBatch: any = false;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns = ['time', 'value', 'outliers', 'rule1', 'rule6', 'rule7'];
  commentsPresent = false;
  gaSummaryRows: any[] = [];

  selectedGranularity: any = {
    cluster: {},
    factory: {}
  };
  period: any;
  skutext: any = '';

  private resolveTotalDataPoints(): number | null {
    const kpi = this.item?.kpi;
    if (!kpi) {
      return null;
    }

    if (this.data.isCapability) {
      return kpi.totalPoints ?? kpi.totalDataPoints ?? null;
    }

    if (this.item?.filter?.outliers) {
      return kpi.totalDataPointsInlcudingManualOutlier ??
        kpi.totalDataPointsIncludingManualOutlier ??
        kpi.totalPoints ??
        kpi.totalDataPoints ??
        null;
    }

    if (this.item?.filter?.obiousOutlier) {
      return kpi.totalPoints ?? kpi.totalDataPoints ?? null;
    }

    return kpi.totalDataPoints ?? kpi.totalPoints ?? null;
  }

  constructor(
    public dialogRef: MatDialogRef<ExportViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExportDialogModel,
    private dataSer: DataService,
    private datePipe: DatePipe,
    private utilSer: UtilsService,
    private requester: RequesterService) {
    this.item = JSON.parse(JSON.stringify(data.item));
    this.period = data.period;

    if (this.item.filter && this.item.filter.outliers) {
      this.item.kpi.avg = this.item.kpi.includingManualOutliersAvg;
      this.item.kpi.sigmaval = this.item.kpi.includingManualOutliersSigmaval;
      this.item.kpi.xcp = this.item.kpi.xcpIncludingManualOutliers;
      this.item.kpi.xcpk = this.item.kpi.xcpkIncludingManualOutliers;
    }
    if (this.item.filter && this.item.filter.obiousOutlier) {
      this.item.kpi.avg = this.item.kpi.withOutliersAvg;
      this.item.kpi.sigmaval = this.item.kpi.withOutliersSigmaval;
      this.item.kpi.xcp = this.item.kpi.xcpWithOutLiers;
      this.item.kpi.xcpk = this.item.kpi.xcpkWithOutLiers;
    }
    this.item.kpi.totalDataPoints = this.resolveTotalDataPoints();

    if (this.item.selectedSku && this.item.selectedSku.name && this.item.selectedSku.name !== null) {
      this.skutext = this.item.selectedSku.name;
    } else if (typeof this.item.selectedSku !== 'object' && this.item.selectedSku && this.item.selectedSku !== null) {
      this.skutext = this.item.selectedSku;
    } else if (this.item.assignedSKUText === '--') {
      this.skutext = 'Latest Run SKU';
    } else {
      this.skutext = this.item.assignedSKUText;
    }
    if (this.skutext === 'Latest Run SKU') {
      this.skutext = this.item.assignedSKUText;
    }
    if (this.data.isCapability) {
      this.displayedColumns.shift();
    }
    if (!this.data.isCapability) {
      this.displayedColumns.push('manualEntryComment', 'manualUserName', 'userEmail');
    }
    if (this.item && this.item.timeSeriesData) {
      this.dataSource.data = JSON.parse(JSON.stringify(this.item.timeSeriesData));
    }
    this.period = data.period;

    if (this.item?.isGA) {
      this.gaSummaryRows = this.buildGaSummaryRows(this.item);
    }
    this.checkAndAddOutlierDetails(this.dataSource.data);
    this.checkAndAddBatchDetails(this.item);

  }

  ngOnInit() {
    this.selectedGranularity = {
      cluster: this.dataSer.getStorageData('selectedCluster') ?
        JSON.parse(this.dataSer.getStorageData('selectedCluster')) : {},
      factory: this.dataSer.getStorageData('selectedFactory') ?
        JSON.parse(this.dataSer.getStorageData('selectedFactory')) : {}
    };
  }

  ngAfterViewInit() {

    const startdateTime = new Date(this.period.split("-")[0]); // Local time
    const enddateTime = new Date(this.period.split("-")[1]); // Local time
    const utcTimestamp1 = Math.floor(startdateTime.getTime() / 1000);
    const utcTimestamp2 = Math.floor(enddateTime.getTime() / 1000);
    console.log('utcTimestamp1:', utcTimestamp1, 'utcTimestamp2:', utcTimestamp2)
    this.dataSource.sort = this.sort;
    const timePeriord = {
      startTime: utcTimestamp1,
      endTime: utcTimestamp2
    }
    this.dataSource.paginator = this.paginator;

    setTimeout(() => {
      this.commentsPresent = false;

      this.requester.getManualOultiers(this.item.tagname, this.dataSource.data, timePeriord).subscribe((resp: any) => {
        if (resp && resp.length) {
          this.mapCommentsToCSVData(this.dataSource.data, resp);
        }
      });
    });
  }

  checkAndAddBatchDetails(item: any) {
    if (item.batch === '1') {
      this.isBatch = true;
      this.displayedColumns.splice(2, 0, 'batch');
    } else {
      this.isBatch = false;
    }
    if (item.isGA) {
      this.displayedColumns.splice(3, 3);
    }
  }

  checkAndAddOutlierDetails(timeSeriesData: any[]) {
    if (timeSeriesData.some(item => item.outlier || item.manualOutlier)) {
      timeSeriesData.forEach(eachData => {
        if (eachData.outlier && !eachData.manualOutlier) {
          eachData.comment = 'SYSTEM GENERATED';
          eachData.userEmail = 'SYSTEM';
          eachData.userNameOutlier = 'SYSTEM';
        } else {
          // MANUAL COMMENTS will be fetched by api later
          eachData.comment = eachData.OutlierComment;
          eachData.userEmail = eachData.OutlieruserId;
          eachData.userNameOutlier = eachData.OutlieruserName;
        }
      });
      this.displayedColumns = [...this.displayedColumns, ...['comment', 'userName', 'userID']];
    }
  }

  mapCommentsToCSVData(timeSeriesData: any, commentDtls: any) {
    if (!Array.isArray(timeSeriesData) || !Array.isArray(commentDtls)) {
      return;
    }

    commentDtls.forEach((eachComment: any) => {
      if (!Array.isArray(eachComment?.myEpochs)) {
        return;
      }

      eachComment.myEpochs.forEach((eachTS: any) => {
        for (const eachData of timeSeriesData) {
          if (eachData.tsEpoch === eachTS && eachData.manualOutlier) {
            if (!this.commentsPresent) {
              this.commentsPresent = true;
            }
            eachData.comment = eachComment.comment;
            eachData.userEmail = eachComment.userId;
            eachData.userNameOutlier = eachComment.userName;
          }
        }
      });
    });
  }

  private normalizeGaNumericValue(value: number): number {
    if (!Number.isFinite(value)) {
      return value;
    }
    const normalizedValue = Number(value.toFixed(15));
    return Object.is(normalizedValue, -0) ? 0 : normalizedValue;
  }

  public convertGaValue(value: any, conversionFactor: any): any {
    if (value === null || value === undefined || value === '') {
      return value;
    }
    const factor = Number(conversionFactor);
    if (!Number.isFinite(factor) || factor === 0) {
      return value;
    }
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return value;
    }
    return this.normalizeGaNumericValue(numericValue * factor);
  }

  private getGaValue(kpi: any, field: string): any {
    if (!kpi) {
      return null;
    }
    return kpi[field] ?? null;
  }

  public formatGaMetric(value: any, digits = 4): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return '';
    }
    return numericValue.toFixed(digits);
  }

  private buildGaSummaryRows(item: any): any[] {
    const kpi = item?.kpi ?? {};
    const conversionFactor = item?.conversionFactor ? item.conversionFactor : 1;
    const toNumber = (value: any): number | null => {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      const numericValue = Number(value);
      return Number.isFinite(numericValue) ? numericValue : null;
    };

    return this.gaSummaryDefinitions.map((definition: any) => ({
      gaVariant: definition.label,
      lsl: kpi.lsl,
      usl: kpi.usl,
      targetVolume: this.convertGaValue(this.getGaValue(kpi, definition.targetPacked), conversionFactor),
      actualPacked: this.convertGaValue(this.getGaValue(kpi, definition.actualPacked), conversionFactor),
      giveAway: this.convertGaValue(this.getGaValue(kpi, definition.giveAway), conversionFactor),
      giveAwayPercentage: toNumber(this.getGaValue(kpi, definition.giveAwayPercentage)),
      lslRejectPercentage: toNumber(this.getGaValue(kpi, definition.lslRejectPercentage)),
      totalDataPoints: this.getGaValue(kpi, definition.totalDataPoints)
    }));
  }

  private buildGaCsvRows(csvInput: any[], item: any, comments: boolean): any[] {
    const summaryRows = this.gaSummaryRows.map((row: any) => ({
      gaVariant: row.gaVariant,
      lsl: row.lsl,
      usl: row.usl,
      targetVolume: row.targetVolume,
      actualPacked: row.actualPacked,
      giveAway: row.giveAway,
      giveAwayPercentage: row.giveAwayPercentage,
      lslRejectPercentage: row.lslRejectPercentage,
      totalDataPoints: row.totalDataPoints
    }));

    const dataRows = csvInput.map((eachPoint: any) => {
      const obj: any = {
        gaVariant: '',
        lsl: '',
        usl: '',
        targetVolume: '',
        actualPacked: '',
        giveAway: '',
        giveAwayPercentage: '',
        lslRejectPercentage: '',
        totalDataPoints: ''
      };

      if (!this.data.isCapability) {
        obj.convertedTS = this.utilSer.csvConverter(eachPoint.convertedTS);
      }
      obj.value = this.convertGaValue(eachPoint.value, item?.conversionFactor ? item.conversionFactor : 1);
      if (this.isBatch) {
        obj.batch = eachPoint.batch;
      }
      obj.manualOutlier = eachPoint.manualOutlier ? eachPoint.manualOutlier : eachPoint.outlier;
      if (!item.isGA) {
        obj.ruleViolation1 = eachPoint.ruleViolation1;
        obj.ruleViolation6 = eachPoint.ruleViolation6;
        obj.ruleViolation7 = eachPoint.ruleViolation7;
      }
      if (!this.data.isCapability) {
        obj.manualEntryComment = eachPoint.manualEntryComment;
        obj.userName = eachPoint.userName;
        obj.userId = eachPoint.userId;

        if (eachPoint.outlier && !eachPoint.manualOutlier) {
          obj.comment = 'SYSTEM GENERATED';
          obj.userEmail = 'SYSTEM';
          obj.userNameOutlier = 'SYSTEM';
        } else {
          obj.comment = eachPoint.OutlierComment;
          obj.userNameOutlier = eachPoint.OutlieruserName;
          obj.userEmail = eachPoint.OutlieruserId;
        }
      }

      if (comments || csvInput.some((point: any) => point.outlier)) {
        obj.comment = eachPoint.comment;
        obj.userNameOutlier = eachPoint.userNameOutlier;
        obj.userEmail = eachPoint.userEmail;
      }
      return obj;
    });

    return [...summaryRows, ...dataRows];
  }

  private escapeCsvValue(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    const text = String(value);
    return /[",\n\r]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
  }

  private buildCsvRow(values: any[]): string {
    return values.map((value) => this.escapeCsvValue(value)).join(',');
  }

  private downloadCsvContent(filename: string, csvContent: string): void {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  }

  generateCSV(item: any, comments = true) {
    const conversionFactor = item && item.conversionFactor ? item.conversionFactor : (this.item && this.item.conversionFactor ? this.item.conversionFactor : 1);
    const csvInput: any = JSON.parse(JSON.stringify(this.dataSource.data));
    const dateTime: any = this.datePipe.transform(new Date(), 'MMM-d-y(HH-mm-ss)');
    // const skuName = item.selectedSku.name ? item.selectedSku.name : item.selectedSku;
    let generatedTitle = 'Applied Filters & KPIs are : ';
    generatedTitle = generatedTitle + 'Line - ' + item.linename;
    generatedTitle = generatedTitle + ', Machine - ' + item.machinename;
    generatedTitle = generatedTitle + ', Parameter - ' + item.parametername;
    generatedTitle = generatedTitle + '(Criticality - ' + item.classification + ')';
    generatedTitle = generatedTitle + ', Period - ' + this.period;
    generatedTitle = generatedTitle + ', SKUs -' + this.skutext;
    generatedTitle = generatedTitle + ', LSL - ' + item.kpi.lsl;
    generatedTitle = generatedTitle + ', USL - ' + item.kpi.usl;
    if (item.isGA) {
      generatedTitle = generatedTitle + ', GA KPI Summary - 3 rows (Without outlier, With Obvious Outlier, With Outlier)';
    } else {
      generatedTitle = generatedTitle + ', LCL - ' + item.kpi.lcl;
      generatedTitle = generatedTitle + ', UCL - ' + item.kpi.ucl;
      generatedTitle = generatedTitle + ', Average - ' + item.kpi.avg;
      if (this.data.isCapability) {
        generatedTitle = generatedTitle + ', Sigma - ' + item.kpi.sigmaval;
        generatedTitle = generatedTitle + ', CP - ' + item.kpi.xcp;
        generatedTitle = generatedTitle + ', CPK - ' + item.kpi.xcpk;
      } else {
        generatedTitle = generatedTitle + ', SD - ' + item.kpi.sigmaval;
        generatedTitle = generatedTitle + ', PP - ' + item.kpi.xcp;
        generatedTitle = generatedTitle + ', PPK - ' + item.kpi.xcpk;
      }
    }
    if (!item.isGA) {
      generatedTitle = generatedTitle + ', Total Data Points - ' + this.resolveTotalDataPoints();
    }
    if (!item.isGA) {
      if (this.data.isCapability) {
        generatedTitle = generatedTitle + ',\n(**CP CPK AVG LCL UCL values are calculated excluding outliers)\n';
      } else {
        generatedTitle = generatedTitle + ',\n(**PP PPK AVG LCL UCL values are calculated excluding outliers)\n';
      }
    }
    if (csvInput) {
      const data = csvInput.map((eachPoint: any) => {
        const obj: any = {};
        if (!this.data.isCapability) {
          obj.convertedTS = this.utilSer.csvConverter(eachPoint.convertedTS);
        }
        obj.value = eachPoint.value;
        if (this.isBatch) {
          obj.batch = eachPoint.batch;
        }
        obj.manualOutlier = eachPoint.manualOutlier ? eachPoint.manualOutlier : eachPoint.outlier;
        if (!item.isGA) {
          obj.ruleViolation1 = eachPoint.ruleViolation1;
          obj.ruleViolation6 = eachPoint.ruleViolation6;
          obj.ruleViolation7 = eachPoint.ruleViolation7;
        }
        if (!this.data.isCapability) {
          obj.manualEntryComment = eachPoint.manualEntryComment;
          obj.userName = eachPoint.userName;
          obj.userId = eachPoint.userId;

          if (eachPoint.outlier && !eachPoint.manualOutlier) {
            obj.comment = 'SYSTEM GENERATED';
            obj.userEmail = 'SYSTEM';
            obj.userNameOutlier = 'SYSTEM';
          } else {
            obj.comment = eachPoint.OutlierComment;
            obj.userNameOutlier = eachPoint.OutlieruserName;
            obj.userEmail = eachPoint.OutlieruserId;
          }
        }

        if (comments || csvInput.some((point: any) => point.outlier)) {
          obj.comment = eachPoint.comment;
          obj.userNameOutlier = eachPoint.userNameOutlier;
          obj.userEmail = eachPoint.userEmail;
        }
        return obj;
      });

      if (item.isGA) {
        const summaryHeaders = [
          'KPI VARIANT',
          'LSL',
          'USL',
          'TARGET VOLUME',
          'ACTUAL PACKED',
          'EXCESS GIVE AWAY',
          'EXCESS GA%',
          'LSL REJECT %',
          'TOTAL DATA POINTS'
        ];
        const summaryBlock = [
          this.buildCsvRow(summaryHeaders),
          ...this.gaSummaryRows.map((row: any) => this.buildCsvRow([
            row.gaVariant,
            row.lsl,
            row.usl,
            row.targetVolume,
            row.actualPacked,
            row.giveAway,
            row.giveAwayPercentage,
            row.lslRejectPercentage,
            row.totalDataPoints
          ]))
        ].join('\n');

        const metadataRow = this.buildCsvRow([
          'Applied Filters & KPIs are :',
          'Line',
          item.linename,
          'Machine',
          item.machinename,
          'Period',
          this.period,
          'SKU',
          this.skutext
        ]);

        const dataHeaders = !this.data.isCapability ? (this.isBatch
          ? [
            'TIME',
            'BATCH',
            'VALUE',
            'OUTLIERS',
            'MANUAL ENTRY COMMENT',
            'ENTERED BY (USER)',
            'ENTERED BY (ID)',
            'RULE1VIOLATION',
            'RULE6VIOLATION',
            'RULE7VIOLATION',
            'OUTLIER COMMENT',
            'MARKED BY (USER)',
            'MARKED BY (ID)'
          ]
          : [
            'TIME',
            'VALUE',
            'OUTLIERS',
            'MANUAL ENTRY COMMENT',
            'ENTERED BY (USER)',
            'ENTERED BY (ID)',
            'RULE1VIOLATION',
            'RULE6VIOLATION',
            'RULE7VIOLATION',
            'OUTLIER COMMENT',
            'MARKED BY (USER)',
            'MARKED BY (ID)'
          ]) : (this.isBatch
            ? [
              'BATCH',
              'VALUE',
              'OUTLIERS',
              'RULE1VIOLATION',
              'RULE6VIOLATION',
              'RULE7VIOLATION',
              'OUTLIER COMMENT',
              'MARKED BY (USER)',
              'MARKED BY (ID)'
            ]
            : [
              'VALUE',
              'OUTLIERS',
              'RULE1VIOLATION',
              'RULE6VIOLATION',
              'RULE7VIOLATION',
              'OUTLIER COMMENT',
              'MARKED BY (USER)',
              'MARKED BY (ID)'
            ]);

        const dataRowsText = data.map((row: any) => {
          const values = !this.data.isCapability ? [
            this.utilSer.csvConverter(row.convertedTS),
            ...(this.isBatch ? [row.batch] : []),
            row.value,
            row.manualOutlier,
            row.manualEntryComment,
            row.userName,
            row.userId,
            row.ruleViolation1,
            row.ruleViolation6,
            row.ruleViolation7,
            row.comment,
            row.userNameOutlier,
            row.userEmail
          ] : [
            ...(this.isBatch ? [row.batch] : []),
            row.value,
            row.manualOutlier,
            row.ruleViolation1,
            row.ruleViolation6,
            row.ruleViolation7,
            row.comment,
            row.userNameOutlier,
            row.userEmail
          ];
          return this.buildCsvRow(values);
        }).join('\n');

        const csvContent = [
          metadataRow,
          '',
          summaryBlock,
          '',
          this.buildCsvRow(dataHeaders),
          dataRowsText
        ].join('\n');
        this.downloadCsvContent(item.parametername + '_' + dateTime + '.csv', csvContent);
        return;
      }

      const baseColumnHeaders = [
        { key: 'value', displayLabel: 'VALUE' },
        { key: 'manualOutlier', displayLabel: 'OUTLIERS' },
        { key: 'ruleViolation1', displayLabel: 'RULE1VIOLATION' },
        { key: 'ruleViolation6', displayLabel: 'RULE6VIOLATION' },
        { key: 'ruleViolation7', displayLabel: 'RULE7VIOLATION' }
      ];

      const csvConfig = mkConfig({
        fieldSeparator: ',',
        decimalSeparator: '.',
        showTitle: true,
        useBom: true,
        columnHeaders: [...baseColumnHeaders],
        filename: item.parametername + '_' + dateTime,
        title: generatedTitle
      });

      if (!this.data.isCapability) {
        csvConfig.columnHeaders.unshift({
          key: 'convertedTS',
          displayLabel: 'TIME'
        });
        csvConfig.columnHeaders.push(
          { key: 'manualEntryComment', displayLabel: 'MANUAL ENTRY COMMENT' },
          { key: 'userName', displayLabel: 'ENTERED BY (USER)' },
          { key: 'userId', displayLabel: 'ENTERED BY (ID)' }
        );
      }
      if (comments || data.some(point => point.manualOutlier)) {
        csvConfig.columnHeaders.push(
          { key: 'comment', displayLabel: 'OUTLIER COMMENT' },
          { key: 'userNameOutlier', displayLabel: 'MARKED BY (USER)' },
          { key: 'userEmail', displayLabel: 'MARKED BY (ID)' }
        );
      }

      if (this.isBatch) {
        csvConfig.columnHeaders.splice(2, 0, { key: 'batch', displayLabel: 'BATCH' });
      }

      const csv = generateCsv(csvConfig)(data);
      download(csvConfig)(csv);
    }
  }

  documentDownload() {
    this.generateCSV(this.item, this.commentsPresent);
  }
}


export class ExportDialogModel {

  constructor(public item: any, public period: any, public isCapability: any) {
  }
}

